import React from 'react';
import PropTypes from 'prop-types';

const linkCls = 'ft-footer__link ft-links__link';

const LinksColumn = ({ columnData: { links, sectionLink } }) => (
  <div className="ft-links__column">
    <h4 className="ft-links__title">
      <a href={sectionLink.url} className="ft-footer__link">{sectionLink.title}</a>
    </h4>
    <ul className="ft-links__list">
      {links.map((link, lidx) => (
        <li
          key={lidx} // eslint-disable-line react/no-array-index-key
        >
          <a href={link.url} className={linkCls}>{link.title}</a>
        </li>
      ))}
    </ul>
  </div>
);

LinksColumn.propTypes = {
  columnData: PropTypes.shape({
    sectionLink: PropTypes.shape({
      title: PropTypes.string.isRequired,
    }),
    links: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      })
    ),
  }),
};

export default LinksColumn;
